interface ArticleSchemaProps {
  headline: string;
  description: string;
  /** Absolute URL of the article page */
  url: string;
  /** Absolute URL of the hero image */
  image: string;
  /** ISO 8601 date string (yyyy-mm-dd) */
  datePublished?: string;
  dateModified?: string;
}

const DEFAULT_DATE = "2025-01-01";

/**
 * Emits Article JSON-LD with Juan Hernandez as author and
 * Juan The Trailer Guy as publisher. Renders nothing visible.
 */
export default function ArticleSchema({
  headline,
  description,
  url,
  image,
  datePublished = DEFAULT_DATE,
  dateModified,
}: ArticleSchemaProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    image,
    datePublished,
    dateModified: dateModified || datePublished,
    author: {
      "@type": "Person",
      "@id": "https://www.juanthetrailerguy.com/#juan",
      name: "Juan Hernandez",
      alternateName: "Juan The Trailer Guy",
      url: "https://www.juanthetrailerguy.com/about",
      jobTitle: "Trailer Educator",
    },
    reviewedBy: {
      "@type": "Person",
      "@id": "https://www.juanthetrailerguy.com/#juan",
      name: "Juan Hernandez",
    },
    publisher: {
      "@type": "Organization",
      name: "Juan The Trailer Guy",
      logo: {
        "@type": "ImageObject",
        url: "https://www.juanthetrailerguy.com/images/jtg-logo-preview.png",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}